import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import SelectAllTransferList from './AssignCheckList';
import { db } from '../service/Firebase-config';
import { updateDoc, doc, onSnapshot, collection, query, where, getDoc, documentId } from '@firebase/firestore';
import { useGlobalContext } from '../context/GlobalContext';

const DialogAssign = ({ open, handleClose }) => {
  const { selectedUser, setSelectedUser } = useGlobalContext();
  const isStudent = selectedUser?.role === 'student';
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [updatedList, setUpdatedList] = useState([]);

  const handleAssigned = async () => {
    try {
      const updatePromises = right.map(async (item) => {
        const selectedRowRef = doc(db, isStudent ? 'teachers' : 'students', item.uid);
        const listKey = isStudent ? 'studentList' : 'teacherList';
        
        const currentList = Array.isArray(item[listKey]) ? item[listKey] : [];
        
        await updateDoc(selectedRowRef, {
          [listKey]: [...currentList, selectedUser?.uid]
        });
        return item.uid;
      });
  
      const updatedItemList = await Promise.all(updatePromises);
  
      const selectedUserRef = doc(db, isStudent ? 'students' : 'teachers', selectedUser.uid);
      const userListKey = isStudent ? 'teacherList' : 'studentList';
  
      const currentUpdatedList = Array.isArray(updatedList) ? updatedList : [];
      
      await updateDoc(selectedUserRef, {
        [userListKey]: [...currentUpdatedList, ...updatedItemList]
      });
  
      const updatedInfo = await getDoc(doc(db, isStudent ? 'students' : 'teachers', selectedUser.uid));
      setSelectedUser(updatedInfo.data());
  
      handleClose();
    } catch (error) {
      console.error("Error updating assignments: ", error);
    }
  };
  
  useEffect(() => {
    if (open) {
      setUpdatedList(selectedUser[isStudent ? 'teacherList' : 'studentList'] || []);
      const hasListCondition = selectedUser[isStudent ? 'teacherList' : 'studentList']?.length > 0
        ? where(documentId(), 'not-in', selectedUser[isStudent ? 'teacherList' : 'studentList'])
        : null;
      const collectionRef = collection(db, isStudent ? 'teachers' : 'students');
      const activeCondition = where('active', '==', true);
      const whereQuery = hasListCondition
      ? query(collectionRef, hasListCondition, activeCondition)
      : query(collectionRef, activeCondition);

      const unsubscribe = onSnapshot(whereQuery, (snapshot) => {
        setLeft(snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
      });

      return () => unsubscribe();
    } else {
      setLeft([]);
      setRight([]);
      setUpdatedList([]);
    }
  }, [open, selectedUser, isStudent]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll='paper'
      PaperProps={{
        sx: {
          minWidth: '60%',
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle>Assign {isStudent ? 'Teacher' : 'Student'}</DialogTitle>
      <DialogContent dividers>
        <SelectAllTransferList open={open} left={left} setLeft={setLeft} right={right} setRight={setRight} isStudent={isStudent} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAssigned}>Submit</Button>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogAssign;
